<template>
  <div>
    <v-text-field
      v-model="cardholderName"
      :rules="[v => !!v || 'Cardholder name is required']"
      label="Cardholder Name"
      outlined
      required
      dense
    />
    <div
      class="card_input"
      id="card-element"
    />
    <div
      class="v-text-field__details"
      style="padding-left: 10px; margin-bottom: 8px"
    >
      <div
        class="v-messages theme--light error--text"
        role="alert"
      >
        <div
          class="v-messages__wrapper"
        >
          <div
            v-if="errorMessage"
            class="v-messages__message"
          >
            {{ errorMessage }}
          </div>
        </div>
      </div>
    </div>
    <v-text-field
      v-model="billingPostcode"
      :rules="[v => !!v || 'Billing postcode is required']"
      label="Billing Postcode"
      outlined
      required
      dense
    />

    <v-alert
      v-if="serverErrorMessage.message"
      class="mt-2"
      outlined
      border="top"
      type="error"
    >
      {{ serverErrorMessage.message }}
      <template v-for="error in serverErrorMessage.errors">
        <p class="mt-2 mb-0" v-for="(message, key) in error" :key="key"><strong>{{ message }}</strong></p>
      </template>
    </v-alert>
  </div>
</template>
<script type="text/javascript">
import axios from 'axios'
export default {
  name: 'PaymentForm',

  props: {
    paymentLink: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      stripeInstance: null,
      elements: null,
      cardElement: null,
      loading: false,
      cardholderName: null,
      billingPostcode: null,
      serverErrorMessage: {},
      errorMessage: null,
      stripeIsComplete: false,
      paymentIntent: {}
    }
  },

  watch: {
    loading: function () {
      this.$emit('update:loading', this.loading)
    },

    stripeIsComplete: function () {
      this.$emit('update:stripeIsComplete', this.stripeIsComplete)
    }
  },

  mounted () {
    this.getPaymentIntent()

    // eslint-disable-next-line
    this.stripeInstance = Stripe(process.env.VUE_APP_STRIPE_KEY)

    var style = {
      base: {
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: '16px',
        fontFamily: '"Roboto"',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          color: '#646464'
        }
      }
    }

    this.elements = this.stripeInstance.elements({ fonts: [{ cssSrc: 'https://fonts.googleapis.com/css?family=Roboto' }] })
    this.cardElement = this.elements.create('card', { style: style, hidePostalCode: true })
    this.cardElement.mount('#card-element')

    this.cardElement.on('change', ($e) => {
      this.stripeIsComplete = $e.complete
      if ($e.error) {
        this.errorMessage = $e.error.message
      } else {
        this.errorMessage = null
      }
    })
  },

  methods: {
    getPaymentIntent () {
      this.loading = true
      const axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_API_BASE_URL
      })
      axiosInstance.defaults.headers.common['Client-Id'] = process.env.VUE_APP_CLIENT_ID
      axiosInstance.post('api/payments', {
        payment_link_id: this.paymentLink.id,
        booking_id: this.paymentLink.booking.id
      })
        .then(({ data: paymentIntent }) => {
          this.paymentIntent = paymentIntent
          this.serverErrorMessage = {}
        })
        .catch(({ response: { data: error } }) => {
          this.serverErrorMessage = error
        })
        .finally(() => { this.loading = false })
    },

    handlePayment () {
      this.errorMessage = null
      this.serverErrorMessage = null
      this.loading = true

      // If we want to charge the card
      if (this.paymentIntent.object === 'payment_intent') {
        this.stripeInstance.confirmCardPayment(this.paymentIntent.client_secret, {
          payment_method: {
            card: this.cardElement,
            billing_details: {
              name: this.cardholderName,
              address: {
                postal_code: this.billingPostcode
              }
            }
          },
          setup_future_usage: 'off_session'
        }).then((result) => {
          if (result.error) {
            this.loading = false
            this.errorMessage = result.error.message
          } else {
            // The payment has been processed!
            if (result.paymentIntent.status === 'succeeded') {
              this.loading = false
              this.$emit('paymentComplete', result)
            }
          }
        })
      } else if (this.paymentIntent.object === 'setup_intent') {
        this.stripeInstance.confirmCardSetup(this.paymentIntent.client_secret, {
          payment_method: {
            card: this.cardElement,
            billing_details: {
              name: this.cardholderName,
              address: {
                postal_code: this.billingPostcode
              }
            }
          }
        })
          .then((result) => {
            if (result.error) {
              this.loading = false
              this.errorMessage = result.error.message
            } else {
              // The payment has been processed!
              if (result.setupIntent.status === 'succeeded') {
                this.loading = false
                this.$emit('paymentComplete', result)
              }
            }
          })
      }
    }
  }
}
</script>
<style type="text/css">
  .card_input {
    margin-bottom: 5px;
    padding: 10px 10px;
    border-radius: 5px;
    border-width: thin;
    border-style: solid;
    border-color: #bebebe;
  }
  .card_input:hover {
    border-color: black;
  }
  .StripeElement--focus {
    border-color: #00a09b!important;
    border-width: 2px;
    margin-bottom: 3px;
  }
  .StripeElement--invalid {
    border-color: #ff0000!important;
    border-width: 2px!important;
  }
</style>
